// Thematic SEO landing pages — high-intent queries for VSP drivers.
// Kept dependency-free (no imports) so the prerender script can load it too.
export const THEMATIC_PATH = "";

export const THEMATIC_PAGES = [
  {
    slug: "gps-gratuit-voiture-sans-permis",
    path: "/gps-gratuit-voiture-sans-permis",
    metaTitle:
      "GPS gratuit pour voiture sans permis (VSP), sans inscription | vspo",
    metaDescription:
      "vspo est un GPS 100 % gratuit et libre pour voiture sans permis (VSP), sans inscription : itinéraires 45 km/h sans autoroute ni voie rapide, navigation vocale et trafic en temps réel.",
    kicker: "GPS gratuit VSP",
    h1: "GPS gratuit pour voiture sans permis",
    intro:
      "Vous cherchez un GPS gratuit et fiable pour votre voiture sans permis ? vspo s'utilise directement dans le navigateur, sans inscription ni application à installer, et calcule des trajets adaptés aux voiturettes limitées à 45 km/h.",
    body: [
      {
        h2: "Un GPS 100 % gratuit et sans inscription",
        paragraphs: [
          "vspo est entièrement gratuit et libre d'accès : pas de compte à créer, pas d'abonnement, pas d'application à télécharger. Vous ouvrez la carte, vous entrez votre départ et votre arrivée, et l'itinéraire se calcule immédiatement.",
          "Le service fonctionne sur téléphone comme sur ordinateur, directement depuis votre navigateur web.",
        ],
      },
      {
        h2: "Pensé pour les voitures sans permis (45 km/h)",
        paragraphs: [
          "Contrairement aux GPS classiques, vspo évite automatiquement les autoroutes, voies rapides et voies pour automobiles interdites aux VSP. Les trajets sont calculés à la vitesse réelle d'une voiturette, ce qui donne des temps de parcours réalistes.",
          "Vous profitez aussi de la navigation vocale en français, du trafic en temps réel, de la recherche d'adresses précises et des lieux d'intérêt (stations, supermarchés, bornes de recharge).",
        ],
      },
      {
        h2: "Gratuit ne veut pas dire limité",
        paragraphs: [
          "Favoris, partage d'itinéraires, alertes d'incidents, suivi de la batterie pour les modèles électriques : toutes les fonctionnalités de vspo restent gratuites. C'est un projet libre d'accès, pensé pour la communauté des conducteurs de voiture sans permis.",
        ],
      },
    ],
    faq: [
      {
        q: "vspo est-il vraiment gratuit ?",
        a: "Oui, vspo est un GPS 100 % gratuit et libre d'accès pour voiture sans permis, sans inscription ni abonnement.",
      },
      {
        q: "Faut-il créer un compte ou installer une application ?",
        a: "Non. vspo s'utilise directement depuis votre navigateur, sans compte ni installation.",
      },
    ],
  },
  {
    slug: "eviter-voies-rapides-voiture-sans-permis",
    path: "/eviter-voies-rapides-voiture-sans-permis",
    metaTitle:
      "Éviter les voies rapides en voiture sans permis (VSP) | vspo",
    metaDescription:
      "Comment éviter autoroutes, voies rapides et voies pour automobiles en voiture sans permis (VSP) : règles, pièges des GPS classiques et itinéraires sûrs à 45 km/h avec vspo.",
    kicker: "Éviter les voies rapides",
    h1: "Éviter les voies rapides en voiture sans permis",
    intro:
      "Les voitures sans permis sont interdites sur les autoroutes, les voies rapides et les voies pour automobiles. vspo trace des itinéraires qui évitent automatiquement ces axes, pour rouler en toute légalité et en sécurité à 45 km/h.",
    body: [
      {
        h2: "Quelles voies sont interdites aux VSP ?",
        paragraphs: [
          "Les quadricycles légers (VSP) ne peuvent légalement pas emprunter les autoroutes, mais aussi les voies rapides urbaines, rocades, périphériques et voies express signalées comme « voies pour automobiles ». Ces axes imposent des vitesses minimales incompatibles avec les 45 km/h d'une voiturette.",
          "S'y engager est dangereux et verbalisable : il est essentiel de disposer d'un itinéraire réellement adapté.",
        ],
      },
      {
        h2: "Le piège des GPS classiques",
        paragraphs: [
          "Même en activant l'option « éviter les autoroutes », la plupart des applications laissent passer des voies rapides urbaines également interdites aux VSP. Résultat : des trajets impossibles à suivre, ou des détours improvisés une fois sur la route.",
          "Les GPS classiques raisonnent aussi à la vitesse d'une voiture ordinaire, ce qui fausse complètement les temps de parcours en voiturette.",
        ],
      },
      {
        h2: "Comment vspo évite les voies rapides",
        paragraphs: [
          "vspo évite nativement les autoroutes et les ferries, puis applique des zones d'évitement sur les voies rapides françaises incompatibles avec les VSP. Vous pouvez même ajouter vos propres voies interdites, mémorisées pour vos prochains trajets.",
          "L'itinéraire reste sur le réseau ordinaire, à 45 km/h, avec navigation vocale et trafic en temps réel pour contourner les bouchons.",
        ],
      },
    ],
    faq: [
      {
        q: "Une voiture sans permis peut-elle rouler sur une rocade ou un périphérique ?",
        a: "Non, si la voie est signalée comme voie rapide ou voie pour automobiles. vspo évite automatiquement ces axes lors du calcul d'itinéraire.",
      },
      {
        q: "Puis-je ajouter mes propres routes interdites ?",
        a: "Oui. vspo permet d'ajouter des voies à éviter, qui sont prises en compte pour vos futurs itinéraires.",
      },
    ],
  },
];

export function findThematic(slug) {
  return THEMATIC_PAGES.find((t) => t.slug === slug) || null;
}
